export class CreatePersonnageCommand {
    nom!: string;
    legion: number|undefined;
    astre1: number|undefined;
    astre2: number|undefined;
 }

 export class UpdateJoueurCommand {
    nomComplet!: string;
    adresse!: string;
    telephone!: string;
    dateDeNaissance: Date|undefined;
    autreInformation!: string;
    contactNomComplet!: string;
    contactRelation!: string;
    contactNumero!: string;
 }

 export class UpdateBackgroundCommand{
    personnageId: number = 0;
    personnalite!: string;
    concept!: string;
    historique!: string;
    butCourtTerme!: string;
    butMoyenTerme!: string;
    butLongTerme!: string;
 }

 export class DeletePersonnageCommand {
   personnageId!: number
}